export default __webpack_public_path__ + "static/media/home-icon-1.47b10441.png";